import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { EditBase, Form, TextInput, useRecordContext, useUpdate } from "react-admin";
import { PostalAddress, PostalAddressSchema } from "../model/PostalAddress";
import { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Column } from "../misc/Column";
import { Row } from "../misc/Row";
import { SaveButton2 } from "../buttons/SaveButton2";

export function EditPostalAddressDialog(props: { open: boolean; onClose: () => void }) {
  const { open, onClose } = props;
  const student = useRecordContext<Student>();
  const [update] = useUpdate<Student>();

  const onSubmit = async (postalAddress: PostalAddress) =>
    runSafely(
      () =>
        update("students", {
          id: student.id,
          data: { postalAddress: PostalAddressSchema.parse(postalAddress) },
          previousData: student,
        }),
      {
        errorMessage: "Fehler beim Ändern der Adresse.",
        successMessage: "Addresse erfolgreich geändert.",
        onSuccess: onClose,
      },
    );

  const validate = (data: { [field: string]: any }) => {
    const { postalAddress } = data;
    const errors: { [field: string]: string } = {};
    const cannotBeEmptyMessage = "Darf nicht leer sein.";
    if (!postalAddress.street) {
      errors["postalAddress.street"] = cannotBeEmptyMessage;
    }
    if (!postalAddress.postalCode) {
      errors["postalAddress.postalCode"] = cannotBeEmptyMessage;
    }
    if (!postalAddress.city) {
      errors["postalAddress.city"] = cannotBeEmptyMessage;
    }
    return errors;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{`Adresse von ${student?.name ?? "..."}`}</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <EditBase>
        <Form onSubmit={(data) => onSubmit(data.postalAddress)} validate={validate} warnWhenUnsavedChanges>
          <DialogContent>
            <Column>
              <TextInput source="postalAddress.street" label="Straße" />
              <Row gap={1}>
                <TextInput
                  className="plz-input"
                  source="postalAddress.postalCode"
                  label="Postleitzahl"
                  sx={{ width: "30%" }}
                />
                <TextInput source="postalAddress.city" label="Stadt" sx={{ width: "70%" }} />
              </Row>
            </Column>
          </DialogContent>
          <DialogActions>
            <SaveButton2 />
          </DialogActions>
        </Form>
      </EditBase>
    </Dialog>
  );
}
